import { cn } from "@/lib/utils";

type LogoProps = {
  className?: string;
  tone?: "light" | "dark";
};

export function Logo({ className, tone = "dark" }: LogoProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-2 text-lg font-extrabold tracking-tight",
        tone === "dark" ? "text-ink-950" : "text-white",
        className,
      )}
    >
      <span className="relative inline-flex h-8 w-8 items-center justify-center rounded-lg bg-brand-500 text-white shadow-[0_8px_20px_-8px_rgba(59,130,246,0.9)]">
        <svg
          aria-hidden="true"
          viewBox="0 0 24 24"
          className="h-4 w-4"
          fill="none"
        >
          <path
            d="M4 19V11M10 19V5M16 19v-6M22 19H2"
            stroke="currentColor"
            strokeWidth="2.2"
            strokeLinecap="round"
          />
        </svg>
      </span>
      <span>
        a<span className="text-brand-500">Computer</span>
      </span>
    </span>
  );
}
